<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	import { localReq, postReq } from '../../../../services/http';
	//Helpers
	import {
		get_local_ip,
		isWallDisplay,
		is_gen_2,
		real_id,
	} from '../../../../helpers/interface_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';
	//Stores
	import { rebooting_devices } from 'src/stores/device-runtime/process';
	//Components
	import ModalPrompt from '../../../ModalPrompt.svelte';
	//Design system components
	import { Alert, Button, Text, toast } from '@Shelly/shelly-design-system';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

	export let device;
	let showModal = false;
	const id = real_id(device.id);
	const gen2 = is_gen_2(device);
	let localIp = get_local_ip(id);
	let loading = false;

	const rebootDevice = async () => {
		loading = true;
		let res;
		if (gen2) {
			res = await gen2Request(device, 'Shelly.Reboot', {});
		} else {
			if (localIp) {
				res = await localReq(device, `${localIp}/reboot`, 'post', {});
			} else {
				res = await postReq(`/device/reboot`, {
					id: id,
				});
			}
		}
		if (res.isok) {
			toast.open({ type: 'success', title: $format('reboot_scc_toast') });
			rebooting_devices.update(id);
		} else {
			toast.open({ type: 'danger', title: $format('reboot_err_toast') });
		}
		loading = false;
	};

	let props = {
		title: $format('reboot_device_title', { default: 'Reboot Device?' }),
		text: $format('reboot_device_info_text', {
			default:
				'Rebooting the device will restart its operating system, potentially resolving minor issues and improving overall performance. This action will briefly interrupt device functionality.',
		}),
		button_2: $format('button_cancel'),
		button_1: $format('button_reboot_device', { default: 'Reboot device' }),
		callback: rebootDevice,
	};

	const navigateToSetting = (setting, subSetting) => {
		setSidePanelState({
			type: 'device',
			id: device.id,
		});
		routeToDeviceSettings.setTarget(device.id, setting, subSetting);
	};
</script>

{#if isWallDisplay(device.type)}
	<Alert
		class="mb-xs"
		type={'info'}
		heading={$format('soft_reboot_suggestion', {
			default:
				'Are you sure you want to fully reboot your Shelly device? This may take up to 2 minutes. We recommend using Soft reboot for faster results.',
		})}
		cta={{
			title: capFirstChar(
				$format('button_soft_reboot', {
					default: 'Reboot device',
				}),
			),
		}}
		on:cta_click={() => navigateToSetting('settings', 'soft_reboot')}
	/>
{/if}
<Text styleType="body-small" class="mb-s">{$format('reboot_description')}</Text>

<Button {loading} size="m" width="full" on:click={() => (showModal = true)}
	>{capFirstChar($format('button_reboot'))}</Button
>
{#if showModal}
	<ModalPrompt bind:showModal {props} />
{/if}
